import {
  FaDev,
  FaDribbble,
  FaFacebookF,
  FaGithubAlt,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
} from "../components/Icons";

const social = [
  {
    title: "LinkedIn",
    icon: FaLinkedinIn,
    link: "https://www.linkedin.com/in/shoxrux-juraev-5495101b9/",
    class: "bg-linkedin",
  },
  {
    title: "Facebook",
    icon: FaFacebookF,
    link: "https://www.facebook.com/shoxrux.juraev.92/",
    class: "bg-facebook",
  },
  {
    title: "Instagram",
    icon: FaInstagram,
    link: "https://Jurayev.xyz/instagram",
    class: "bg-instagram",
  },
  {
    title: "GitHub",
    icon: FaGithubAlt,
    link: "https://Jurayev.xyz/github",
    class: "bg-github",
  },
  {
    title: "Dribbble",
    icon: FaDribbble,
    link: "https://Jurayev.xyz/dribbble",
    class: "bg-dribbble",
  },
  {
    title: "DEV Community",
    icon: FaDev,
    link: "https://Jurayev.xyz/dev",
    class: "bg-dev",
  },

  {
    title: "Twitter",
    icon: FaTwitter,
    link: "https://Jurayev.xyz/twitter",
    class: "bg-twitter",
  },
];

export default social;
